import { FormSelectGroupOption } from "../../../../types/Form";

export const reasonLostOptions: FormSelectGroupOption[] = [
  {
    options: [
      "Price",
      "Budget unavailable",
      "Timeline changed",
      "Project canceled",
      "Chose competitor",
      "Stayed with existing vendor",
      "Wrong product fit",
      "Delivery requirements",
      "Incorrect contact",
      "Never engaged",
      "Ghosted",
      "No response after quote",
      "Duplicate opportunity",
      "Internal decision",
      "Other (Required Notes)",
      "Fraud",
    ],
  },
];

export const clientFlagOptions: FormSelectGroupOption[] = [
  {
    options: [
      "Do Not Contact",
      "Voicemail",
      "Strategic Account",
      "Needs Management Approval",
      "High Maintenance",
      "Repeat Client",
      "Fraud",
    ],
  },
];

export const priorityOptions: FormSelectGroupOption[] = [
  {
    options: ["High", "Medium", "Low"],
  },
];

export const closeProbabilityOptions: FormSelectGroupOption[] = [
  {
    options: ["5%", "15%", "25%", "30%", "50%", "75%", "90%", "100%", "0%"],
  },
];

export const waitingOnOptions: FormSelectGroupOption[] = [
  {
    options: [
      "Waiting on Customer Approval",
      "Waiting on Customer Payment",
      "Waiting on Rendering",
      "Waiting on Customer Artwork",
      "Waiting on Vendor Information",
      "Waiting on Sample",
      "Waiting on Customer Response",
      "Sample Sent",
      "Waiting on pricing approval from leadership",
    ],
  },
];
